import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=46fb47d4&scoped=true&"
import script from "./RightSide.vue?vue&type=script&lang=js&"
export * from "./RightSide.vue?vue&type=script&lang=js&"
import style0 from "./RightSide.vue?vue&type=style&index=0&id=46fb47d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb47d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fb47d4')) {
      api.createRecord('46fb47d4', component.options)
    } else {
      api.reload('46fb47d4', component.options)
    }
    module.hot.accept("./RightSide.vue?vue&type=template&id=46fb47d4&scoped=true&", function () {
      api.rerender('46fb47d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/RightSide.vue"
export default component.exports